var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2968 13.5469C32.7297 8.86757 28.6694 2.00524 25.5 1.96028C23.5272 1.93259 21.4113 4.75389 19.8441 9.43304C19.3296 10.9902 18.9042 12.5755 18.5699 14.181C18.4364 14.8158 18.3114 15.4656 18.1949 16.1305C17.8914 17.8691 17.6533 19.7009 17.483 21.6001C17.4096 22.4039 17.3502 23.221 17.3016 24.0472C17.2123 25.5947 17.167 27.1771 17.167 28.7804C17.167 30.3837 17.2123 31.9661 17.3016 33.5136C16.6108 33.0583 15.9348 32.598 15.2738 32.1326C15.2287 31.0286 15.2065 29.9089 15.2065 28.7804C15.2065 27.6519 15.2287 26.5319 15.2738 25.4279C15.3057 24.5948 15.3507 23.7702 15.4087 22.9542C15.5789 20.4491 15.8836 17.9549 16.3215 15.4825C16.4391 14.8233 16.5665 14.1779 16.7037 13.5465C17.044 11.9457 17.4719 10.3648 17.9855 8.81085C19.8883 3.12936 22.5571 0 25.5 0C28.4429 0 31.1105 3.12993 33.0133 8.81085C33.5268 10.3649 33.9551 11.9458 34.2962 13.5465",
    fill: "url(#paint0_linear_5_7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7032 44.0152C18.2702 48.6946 22.3306 55.5571 25.4994 55.6015C27.4722 55.6292 29.5881 52.8079 31.1553 48.1285C31.6698 46.5713 32.0952 44.9861 32.4295 43.3805C32.563 42.7459 32.688 42.0962 32.8045 41.4312C33.108 39.6925 33.3461 37.8608 33.5164 35.9616C33.5898 35.1579 33.6492 34.3405 33.6978 33.5146C33.7871 31.9671 33.8324 30.3847 33.8324 28.7814C33.8324 27.1781 33.7871 25.5957 33.6978 24.0482C34.3886 24.5034 35.0646 24.9637 35.7256 25.4289C35.7707 26.5329 35.7929 27.6529 35.7929 28.7814C35.7929 29.9099 35.7707 31.0296 35.7256 32.1336C35.6937 32.9667 35.6487 33.7913 35.5907 34.6074C35.4205 37.1126 35.1158 39.6068 34.6779 42.0792C34.5603 42.7385 34.4329 43.3834 34.2957 44.0141C33.9554 45.6149 33.5275 47.1958 33.0139 48.7498C31.1111 54.4318 28.4425 57.5612 25.5 57.5612C22.5575 57.5612 19.8895 54.4312 17.9866 48.7501C17.4732 47.1961 17.0449 45.6152 16.7038 44.0145",
    fill: "url(#paint1_linear_5_7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2944 44.0152C39.1304 44.9976 47.1035 44.9126 48.7264 42.1906C49.7372 40.4951 48.3515 37.2527 45.0826 33.5559C43.9914 32.3317 42.8313 31.1707 41.608 30.0785C41.125 29.6453 40.6247 29.2122 40.1071 28.7791C38.7527 27.6476 37.2858 26.5248 35.7263 25.4276C35.067 24.9621 34.3908 24.502 33.698 24.0472C32.4025 23.1961 31.0586 22.3684 29.6662 21.5639C28.2773 20.7619 26.8846 20.0103 25.4998 19.314C26.24 18.9435 26.9766 18.5882 27.7096 18.2483C28.6884 18.7611 29.6673 19.3004 30.6464 19.8662C31.6254 20.432 32.582 21.0101 33.516 21.6005C34.2214 22.0448 34.9131 22.496 35.5909 22.9542C37.6753 24.3543 39.6829 25.8656 41.6049 27.4814C42.117 27.9129 42.6121 28.3459 43.0902 28.7804C44.3065 29.8754 45.4617 31.0365 46.5506 32.2582C50.5195 36.7469 51.8954 40.6227 50.4239 43.1715C48.9525 45.7202 44.9084 46.4657 39.0367 45.2727C37.4342 44.9403 35.8511 44.5208 34.2944 44.016",
    fill: "url(#paint2_linear_5_7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7056 13.5457C11.8696 12.5631 3.89645 12.6483 2.27363 15.3703C1.26275 17.0658 2.64846 20.308 5.91743 24.005C7.00861 25.2292 8.1687 26.3902 9.39204 27.4824C9.875 27.9154 10.3753 28.3485 10.8929 28.7818C12.2473 29.9131 13.7142 31.0359 15.2737 32.1331C15.933 32.5986 16.6091 33.0587 17.302 33.5135C18.5975 34.3648 19.9414 35.1927 21.3338 35.997C22.7227 36.7988 24.1154 37.5505 25.5002 38.2467C24.76 38.6174 24.0234 38.9727 23.2904 39.3126C22.3116 38.7998 21.3327 38.2605 20.3536 37.6947C19.3746 37.1289 18.418 36.5507 17.484 35.9602C16.7785 35.5159 16.0869 35.0647 15.4091 34.6065C13.3247 33.2066 11.3171 31.6956 9.39507 30.0801C8.88303 29.6487 8.38793 29.2157 7.90978 28.781C6.69349 27.6861 5.5383 26.5251 4.4494 25.3034C0.480461 20.8147 -0.895382 16.938 0.576065 14.39C2.04751 11.8421 6.09157 11.096 11.9633 12.2888C13.5658 12.6213 15.1489 13.0409 16.7056 13.5457",
    fill: "url(#paint3_linear_5_7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0911 28.7828C46.3601 25.0861 50.2731 18.1386 48.7271 15.3715C47.764 13.6483 44.2632 13.228 39.4274 14.2098C37.8215 14.5429 36.236 14.9672 34.6784 15.4808C34.0619 15.6824 33.4367 15.899 32.8027 16.1307C31.1456 16.7377 29.4399 17.4469 27.7099 18.249C26.977 18.5871 26.2405 18.9426 25.5001 19.3154C24.1154 20.0118 22.7227 20.7633 21.3337 21.5654C19.9448 22.3674 18.5974 23.1967 17.302 24.0486C17.3513 23.2223 17.412 22.4067 17.4839 21.6016C18.4173 21.0105 19.3739 20.4324 20.3536 19.8672C21.3309 19.303 22.3098 18.7637 23.2904 18.2493C24.0279 17.8603 24.7645 17.4873 25.5001 17.1302C27.7547 16.0249 30.0672 15.0417 32.4273 14.1848C33.057 13.9572 33.6796 13.7448 34.2951 13.5478C35.8517 13.0422 37.4348 12.6223 39.0374 12.29C44.9091 11.0972 48.9536 11.8436 50.4252 14.3923C51.8968 16.941 50.5201 20.8159 46.5513 25.3046C45.4621 26.5261 44.3069 27.6872 43.0911 28.7828",
    fill: "url(#paint4_linear_5_7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90883 28.7793C4.63986 32.4762 0.726873 39.4237 2.27287 42.1906C3.23594 43.9137 6.73672 44.3341 11.5726 43.3522C13.1784 43.0191 14.7639 42.5948 16.3215 42.0813C16.938 41.879 17.5632 41.6623 18.1972 41.4312C19.8544 40.8242 21.5601 40.115 23.2901 39.3129C24.0229 38.9748 24.7595 38.6193 25.4998 38.2465C26.8846 37.5503 28.2773 36.7986 29.6662 35.9967C31.0551 35.1949 32.4025 34.3654 33.6979 33.5133C33.6486 34.3398 33.588 35.1555 33.516 35.9603C32.5826 36.5516 31.6261 37.1298 30.6464 37.6949C29.6691 38.259 28.6901 38.7983 27.7095 39.3127C26.972 39.7016 26.2354 40.0747 25.4998 40.4319C23.2452 41.5372 20.9328 42.5204 18.5726 43.3773C17.9429 43.6049 17.3204 43.8172 16.7049 44.0141C15.1483 44.5199 13.5652 44.9398 11.9626 45.2719C6.09082 46.4649 2.04638 45.7185 0.57474 43.1696C-0.896897 40.6207 0.479892 36.7462 4.44864 32.2575C5.53775 31.0358 6.69274 29.8744 7.90845 28.7785",
    fill: "url(#paint5_linear_5_7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3899 9.77022C33.353 9.77022 34.9445 8.17875 34.9445 6.21557C34.9445 4.25239 33.353 2.66092 31.3899 2.66092C29.4267 2.66092 27.8352 4.25239 27.8352 6.21557C27.8352 8.17875 29.4267 9.77022 31.3899 9.77022Z",
    fill: "url(#paint6_linear_5_7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1072 52.1206C20.3306 52.1206 21.3224 51.1288 21.3224 49.9054C21.3224 48.6819 20.3306 47.6902 19.1072 47.6902C17.8838 47.6902 16.892 48.6819 16.892 49.9054C16.892 51.1288 17.8838 52.1206 19.1072 52.1206Z",
    fill: "url(#paint7_linear_5_7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9238 33.783C13.3976 33.783 14.5922 32.5883 14.5922 31.1146C14.5922 29.6409 13.3976 28.4462 11.9238 28.4462C10.4501 28.4462 9.25543 29.6409 9.25543 31.1146C9.25543 32.5883 10.4501 33.783 11.9238 33.783Z",
    fill: "url(#paint8_linear_5_7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0302 38.9741C49.6699 38.9741 50.9991 37.6449 50.9991 36.0053C50.9991 34.3656 49.6699 33.0364 48.0302 33.0364C46.3905 33.0364 45.0613 34.3656 45.0613 36.0053C45.0613 37.6449 46.3905 38.9741 48.0302 38.9741Z",
    fill: "url(#paint9_linear_5_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_7",
    x1: 24.7516,
    y1: 33.5136,
    x2: 24.7516,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_7",
    x1: 26.248,
    y1: 57.5612,
    x2: 26.248,
    y2: 24.0482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_7",
    x1: 45.6184,
    y1: 46.5995,
    x2: 26.8254,
    y2: 18.7459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_7",
    x1: 22.2108,
    y1: 40.1399,
    x2: 3.41851,
    y2: 12.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_7",
    x1: 28.3212,
    y1: 30.4023,
    x2: 31.7833,
    y2: 6.95655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_7",
    x1: 9.94089,
    y1: 49.2359,
    x2: 13.4032,
    y2: 25.7893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_7",
    x1: 33.1672,
    y1: 9.2939,
    x2: 29.6125,
    y2: 3.13724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_7",
    x1: 20.2148,
    y1: 51.8238,
    x2: 17.9996,
    y2: 47.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_7",
    x1: 13.258,
    y1: 33.4254,
    x2: 10.5896,
    y2: 28.8038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9870FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_7",
    x1: 49.5146,
    y1: 38.5763,
    x2: 46.5458,
    y2: 33.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d230a8d34f4cf7e4b8923c354c7c4581.svg";
export { ForwardRef as ReactComponent };